import { debounce } from 'lodash'

export default {
  data() {
    return {
      isLookupProductsDisabled: false,
      tempProducts: [],
    }
  },

  methods: {
    productImage (skuId) {
      if (!skuId) return this.defaultImages.product
      const product = this.getProductInfoBySkuId(skuId)
      return (product && product.images.thumbnail) || this.defaultImages.product
    },
    lookupProducts: debounce(async function (index, event) {
      if (this.isLookupProductsDisabled || !event) {
        return
      }
      this.items[index].loaded = false
      this.items[index].loading = true
      await this.$store.dispatch('getProducts', {
        page: 1,
        limit: 10,
        q: event,
        no_category: true,
        no_modifier: true,
        no_discount: true,
        no_tax: true,
      })
      this.tempProducts = [
        ...this.tempProducts,
        ...this.products,
      ]
      this.setProductsAvailable()
      this.showFinish(this.$Progress)
      this.items[index].loaded = true
      this.items[index].loading = false
    }, 500),
    handleSelectProduct(index, event) {
      const skuId = event.value
      this.items[index].sku_id = skuId
      this.items[index].image = this.productImage(skuId)
      this.items[index].queryProductName = event.text
      this.items[index].loading = false
      this.optionSkus = []

      this.isLookupProductsDisabled = true
      setTimeout(() => {
        this.isLookupProductsDisabled = false
      }, 600)
    },
    handleInputBlurProduct(index, event) {
      const data = this.items[index]
      if (!data.sku_id && this.optionSkus.length === 0) {
        this.items[index].queryProductName = ''
      }
    },
    handleBlurProduct(index, event) {
      const data = this.items[index]
      if (data.is_saving_product) {
        return
      }
      if (!data.sku_id) {
        this.items[index].queryProductName = ''
      }
    },
    handleKeydownProduct(index, event) {
      this.items[index].loaded = false

      if (this.items[index].sku_id) {
        event.preventDefault()
      }
    },
    handleKeyupProduct(index, event) {
      if (this.isLookupProductsDisabled) {
        return
      }
      if (event.key === 'Backspace' && this.items[index].sku_id) {
        this.items[index].queryProductName = ''
      }
      if (!this.items[index].queryProductName) {
        this.items[index].sku_id = ''
        this.items[index].loading = false
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/orderAutocompleteInventoryStockControl.js